import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/generals/legal-page'

import { LegalPage } from '@/components/generals/legal-page'

import { studio } from '@/constants/site'

const sections: readonly LegalSection[] = [
    {
        heading: 'What this covers',
        paragraphs: [
            `This policy explains what happens to information you hand over when you use this site or write to ${studio.brand}. It is deliberately short, because the site collects very little.`,
            'If something here is unclear, ask. A policy nobody can read is not a policy.'
        ]
    },
    {
        heading: 'What gets collected',
        paragraphs: [
            'The contact form collects the name, email address and message you type into it. Nothing else is taken from that form, and there are no hidden fields beyond a single spam trap that real visitors never see.',
            'Anonymous, aggregated visit statistics are recorded so it is possible to tell which work people actually look at. These do not use cookies and do not identify anybody.'
        ]
    },
    {
        heading: 'How it is used',
        paragraphs: [
            'Messages are used to reply to you. That is the whole purpose. They are not added to a mailing list, not sold, and not passed to anyone else.',
            'Visit statistics are used to decide what to make more of. They are never linked back to an individual.'
        ]
    },
    {
        heading: 'How long it is kept',
        paragraphs: [
            'Messages are kept while a conversation is live and for a reasonable period afterwards, in case it picks up again. You can ask for yours to be deleted at any time and it will be.',
            'Aggregated statistics are kept indefinitely because they contain nothing personal.'
        ]
    },
    {
        heading: 'Third parties',
        paragraphs: [
            'The site runs on hosting and infrastructure providers who process data on its behalf under their own agreements. No advertising networks, trackers or data brokers are involved.',
            'Links out to other sites are exactly that. Once you follow one, their rules apply, not these.'
        ]
    },
    {
        heading: 'Your rights',
        paragraphs: [
            'You can ask what is held about you, ask for it to be corrected, or ask for it to be erased. There is no form for this and no waiting queue; send an email and it gets handled.',
            'If you are in the UK or EU, the usual statutory rights apply in full and nothing here limits them.'
        ]
    }
]

const PrivacyPolicyPage: FC = (): ReactNode => (
    <LegalPage
        title='Privacy policy'
        updated='1 January 2026'
        intro='A short account of what this site collects, why it collects it, and how to make it stop.'
        sections={sections}
    />
)

export default PrivacyPolicyPage
